import { Breakpoints } from "../../breakpoints.js";

if (!window.yotubeSlider || !window.yotubeSlider.length) { // Only run once
  window.yotubeSlider = [];
  const itemClass = 'yotube-slider';

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(`.${itemClass}`).forEach((carouselItem) => {

      const swiper = carouselItem.querySelector('swiper-container');
      if (!!swiper.initialized) return;

      const swiperParams = {
        breakpoints: {
          0: {
            spaceBetween: 24,
          },
          [Breakpoints.sm]: {
            spaceBetween: 24,
          },
          [Breakpoints.md]: {
            spaceBetween: 24,
          },
          [Breakpoints.xl]: {
            spaceBetween: 80,
          },
        },
        // Hack: Inject styles into swiper.
        injectStyles: [`:host .swiper { overflow: visible !important; }`],
      };

      Object.assign(swiper, swiperParams);

      swiper.initialize();

      window.yotubeSlider.push(swiper);
    });
  });
}
